import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdEdit } from "react-icons/md";
import moment from "moment";

const ViewDetailsTest = ({ setViewDetail, selectedData }) => {
  const duesType = (type) => {
    if (type === 1) {
      return <span>Rent</span>;
    } else if (type === 2) {
      return <span>Security</span>;
    } else if (type === 3) {
      return <span>Maintenance</span>;
    } else if (type === 4) {
      return <span>Electricity</span>;
    } else if (type === 5) {
      return <span>Registration</span>;
    } else if (type === 6) {
      return <span>Tech_Changes</span>;
    } else if (type === 7) {
      return <span>Others</span>;
    } else if (type === 8) {
      return <span>Agreement Charges</span>;
    } else if (type === 9) {
      return <span>Food</span>;
    } else if (type === 10) {
      return <span>Fine</span>;
    }
  };
  const onClose = () => {
    setViewDetail(false);
  };

  {/** 
  const onEditBasicAsset = () => {
    setEditBasicAsset(true);
    setViewDetail(false);
  };
  const onEditAssignmentDetails = () => {
    setEditAssignmentDetails(true);
    setViewDetail(false);
  };
  const onEditPurchaseDetails = () => {
    setEditPurchaseDetails(true);
    setViewDetail(false);
  };   
  */}

  return (
    <Container>
      <div className="flex items-center justify-between bg-[#0078BD] py-4 px-4">
        <Heading className="text-white text-lg font-medium">{"Dues Details"}</Heading>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </div>
      <ProfileSection>
        <UserInfo>
          <span className="text-base font-medium mb-0">
            {(selectedData?.tenantName || "Tenant Name")}
          </span>
          <span className="text-sm text-gray-600">
            #{selectedData?.id || "N/A"},{" "}{" "}{selectedData?.propertyName || "Property Name"}
          </span>
        </UserInfo>
      </ProfileSection>

      <Body>
        <Wrapper>
          {/* <Heading>
            <SectionTitle>Dues Detail</SectionTitle>
          </Heading> */}
          <Section>
            <Row>
              <Label>Amount</Label>
              <Value>{'₹' + selectedData?.amount}</Value>
            </Row>
            <Row>
              <Label>Balance</Label>
              <Value>{'₹' + selectedData?.balance}</Value>
            </Row>
            <Row>
              <Label>Dues Type</Label>
              <Value>{duesType(selectedData?.type) || "Dues Type"}</Value>
            </Row>
            <Row>
              <Label>Updated At</Label>
              <Value>{moment(selectedData?.updatedAt).format("DD-MM-YYYY hh:mm A")}</Value>
            </Row>
            <Row>
              <Label>Created At</Label>
              <Value>{moment(selectedData?.createdAt).format("DD-MM-YYYY hh:mm A")}</Value>
            </Row>
          </Section>
        </Wrapper>
      </Body>
    </Container>
  );
};
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Section = tw.div`relative`;
const SectionTitle = tw.h2`text-base font-medium mb-0 flex justify-between items-center`;
const Row = tw.div`flex justify-between py-1 md:p-1`;
const Label = tw.label`text-sm text-gray-500 font-normal`;
const Value = tw.span`text-gray-800 font-medium`;
const SubmitBtn = tw.button`
  flex text-md w-auto md:text-sm text-blue-600 mt-auto hover:text-blue-600 underline
`;
const Body = tw.div`px-4 h-full flex flex-col justify-between py-3 relative`;
const Heading = tw.div`w-full flex items-center justify-between `;

export default ViewDetailsTest;